import React, { useState, useEffect, useRef } from 'react';

// ─── Icons ───────────────────────────────────────────────────────────────────
const BrainIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-6 h-6">
    <path d="M9.5 2a2.5 2.5 0 0 1 2.45 2H15a2 2 0 0 1 2 2v1.5a2.5 2.5 0 1 1 0 5V14a2 2 0 0 1-2 2h-1v1a3 3 0 0 1-6 0v-1H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3.05A2.5 2.5 0 0 1 9.5 2z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6">
    <path d="M3 6h18M3 12h18M3 18h18" strokeLinecap="round"/>
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6">
    <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-5 h-5 text-lavender-400">
    <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const StarIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill={filled ? '#A78BFA' : 'none'} stroke="#A78BFA" strokeWidth="2">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

const ArrowRightIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
    <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PlayStoreIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M3.18 23.76c.36.2.77.25 1.16.15L15.55 12 4.34.09C3.95-.01 3.54.04 3.18.24 2.46.65 2 1.42 2 2.28v19.44c0 .86.46 1.63 1.18 2.04zm1.62-21.1 9.3 9.34-9.3 9.33V2.66zm11.85 9.9L14 11l2.46-1.37 4.1 2.28a.99.99 0 0 1 0 1.74l-4.1 2.28L14 14.65l2.65-2.09zM6.69 1.31l8.06 8.1L13 10.72 6.69 1.31zm0 21.38L13 13.28l1.75 1.31-8.06 8.1z"/>
  </svg>
);

const AppStoreIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const LightbulbIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-7 h-7">
    <path d="M9 21h6M12 3a7 7 0 0 1 7 7c0 2.64-1.46 4.95-3.62 6.19A2 2 0 0 0 14 18H10a2 2 0 0 0-1.38.81C6.46 17.45 5 15.14 5 10a7 7 0 0 1 7-7z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-7 h-7">
    <rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18" strokeLinecap="round"/>
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-7 h-7">
    <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
  </svg>
);

const ZapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-7 h-7">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-7 h-7">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SyncIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-7 h-7">
    <path d="M23 4v6h-6M1 20v-6h6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ─── Navbar ───────────────────────────────────────────────────────────────────
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Features', href: '#features' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'Download', href: '#download' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled ? 'py-3 bg-neutral-950/90 backdrop-blur-xl border-b border-white/5 shadow-glass' : 'py-5'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-xl bg-lavender-gradient flex items-center justify-center shadow-lavender group-hover:shadow-lavender-lg transition-shadow duration-300">
            <BrainIcon />
          </div>
          <span className="font-display font-bold text-xl tracking-tight">
            Mind<span className="gradient-text">Plan</span> AI
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <a key={link.label} href={link.href} className="nav-link">{link.label}</a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a href="#download" className="btn-primary text-sm px-6 py-2.5">
            Get App
            <ArrowRightIcon />
          </a>
        </div>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden text-white/70 hover:text-white transition-colors"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <XIcon /> : <MenuIcon />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden mt-3 mx-4 glass-card p-6 flex flex-col gap-4 animate-fade-up">
          {navLinks.map(link => (
            <a
              key={link.label}
              href={link.href}
              className="nav-link text-base"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a href="#download" className="btn-primary justify-center mt-2 text-sm">
            Get App <ArrowRightIcon />
          </a>
        </div>
      )}
    </nav>
  );
}

// ─── Hero ─────────────────────────────────────────────────────────────────────
function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-hero-gradient">
      {/* Background orbs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-lavender-700/30 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-lavender-500/20 rounded-full blur-3xl animate-pulse-slow animate-delay-300" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-lavender-800/10 rounded-full blur-3xl" />
      </div>

      {/* Grid pattern */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: 'linear-gradient(rgba(139,92,246,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.3) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-20 grid lg:grid-cols-2 gap-16 items-center w-full">
        {/* Text */}
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 bg-lavender-600/20 border border-lavender-500/30 rounded-full px-4 py-2 mb-6 animate-fade-up">
            <span className="w-2 h-2 rounded-full bg-lavender-400 animate-pulse" />
            <span className="text-lavender-300 text-sm font-medium tracking-wide">AI-Powered Mind Planning</span>
          </div>

          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.05] mb-6 animate-fade-up animate-delay-100">
            Think Smarter,<br />
            <span className="gradient-text">Plan Better</span><br />
            with AI
          </h1>

          <p className="text-white/60 text-lg md:text-xl leading-relaxed mb-10 max-w-lg animate-fade-up animate-delay-200">
            MindPlan AI transforms your thoughts into structured, actionable plans using advanced artificial intelligence — so you can focus on what matters most.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 animate-fade-up animate-delay-300">
            <a
              href="https://play.google.com/store"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              <PlayStoreIcon />
              Get on Play Store
            </a>
            <a
              href="https://apps.apple.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              <AppStoreIcon />
              App Store
            </a>
          </div>

          {/* Stats */}
          <div className="flex gap-8 mt-14 animate-fade-up animate-delay-400">
            {[
              { value: '50K+', label: 'Active Users' },
              { value: '4.8', label: 'Play Store Rating' },
              { value: '98%', label: 'Satisfaction Rate' },
            ].map(stat => (
              <div key={stat.label}>
                <p className="font-display text-3xl font-bold gradient-text">{stat.value}</p>
                <p className="text-white/50 text-sm mt-0.5">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Hero image / phone mockup */}
        <div className="relative flex justify-center items-center animate-float">
          <div className="relative">
            {/* Glow ring */}
            <div className="absolute inset-0 rounded-[3rem] bg-lavender-600/30 blur-2xl scale-110 animate-glow" />
            <div className="relative rounded-[3rem] overflow-hidden shadow-lavender-lg border border-lavender-500/30 w-72 md:w-80">
              <img
                src="https://images.unsplash.com/photo-1512314889357-e157c22f938d?w=640&q=80"
                alt="MindPlan AI app interface on phone"
                className="w-full h-auto"
                loading="eager"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-lavender-900/40 to-transparent" />
            </div>

            {/* Floating card 1 */}
            <div className="absolute -left-16 top-12 glass-card px-4 py-3 animate-fade-up animate-delay-200 hidden md:block">
              <p className="text-xs text-white/50 mb-1">Daily Focus</p>
              <p className="font-display font-semibold text-sm text-lavender-300">3 tasks completed</p>
              <div className="flex gap-1 mt-1">
                {[1,2,3].map(i => <div key={i} className="w-6 h-1.5 rounded-full bg-lavender-400" />)}
                {[4,5].map(i => <div key={i} className="w-6 h-1.5 rounded-full bg-white/20" />)}
              </div>
            </div>

            {/* Floating card 2 */}
            <div className="absolute -right-14 bottom-20 glass-card px-4 py-3 animate-fade-up animate-delay-400 hidden md:block">
              <p className="text-xs text-white/50 mb-1">AI Suggestion</p>
              <p className="font-semibold text-sm text-white">Plan generated</p>
              <p className="text-lavender-400 text-xs mt-0.5">in 0.8 seconds</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-neutral-950 to-transparent" />
    </section>
  );
}

// ─── Features ─────────────────────────────────────────────────────────────────
const features = [
  {
    icon: <LightbulbIcon />,
    title: 'AI Mind Mapping',
    desc: 'Transform raw ideas into structured visual mind maps instantly with our advanced AI engine.',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&q=80',
    imageAlt: 'Team brainstorming session',
  },
  {
    icon: <CalendarIcon />,
    title: 'Smart Scheduling',
    desc: 'Automatically arrange your tasks into time-blocked schedules optimized for your peak productivity.',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=600&q=80',
    imageAlt: 'Calendar and planner',
  },
  {
    icon: <TargetIcon />,
    title: 'Goal Tracking',
    desc: 'Set ambitious goals, break them into milestones, and track your progress with visual dashboards.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80',
    imageAlt: 'Analytics dashboard',
  },
  {
    icon: <ZapIcon />,
    title: 'Instant AI Plans',
    desc: 'Describe your project in plain language and get a complete actionable plan in under a second.',
    image: 'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=600&q=80',
    imageAlt: 'AI interface on laptop',
  },
  {
    icon: <ShieldIcon />,
    title: 'Privacy First',
    desc: 'Your thoughts and plans remain private. End-to-end encryption ensures your data is only yours.',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&q=80',
    imageAlt: 'Data security and privacy',
  },
  {
    icon: <SyncIcon />,
    title: 'Cross-Device Sync',
    desc: 'Access all your plans seamlessly across Android, iOS, and web. Always in sync, always ready.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&q=80',
    imageAlt: 'Multiple devices',
  },
];

function Features() {
  return (
    <section id="features" className="py-28 bg-neutral-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-lavender-600/50 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-16">
          <p className="section-subtitle mb-3">What We Offer</p>
          <h2 className="section-title">
            Everything you need to<br />
            <span className="gradient-text">plan with precision</span>
          </h2>
          <p className="text-white/50 text-lg mt-4 max-w-2xl mx-auto leading-relaxed">
            MindPlan AI combines the power of artificial intelligence with intuitive design to give you a planning experience unlike any other.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div key={idx} className="feature-card group flex flex-col gap-4">
              {/* Image */}
              <div className="relative h-44 rounded-xl overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/80 via-neutral-950/20 to-transparent" />
                <div className="absolute bottom-3 left-3 w-10 h-10 rounded-xl bg-lavender-600/80 backdrop-blur-sm flex items-center justify-center text-lavender-200 border border-lavender-400/30">
                  {feature.icon}
                </div>
              </div>

              <h3 className="font-display font-semibold text-xl text-white">{feature.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed flex-1">{feature.desc}</p>

              <div className="flex items-center gap-1 text-lavender-400 text-sm font-medium group-hover:gap-2 transition-all duration-300">
                Learn more <ArrowRightIcon />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── How It Works ─────────────────────────────────────────────────────────────
const steps = [
  {
    number: '01',
    title: 'Describe Your Goal',
    desc: 'Simply type your goal, project, or idea in plain English. No templates, no rigid forms — just your thoughts.',
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?w=700&q=80',
    imageAlt: 'Person typing on laptop',
  },
  {
    number: '02',
    title: 'AI Generates Your Plan',
    desc: 'Our AI analyzes your input and instantly creates a structured, step-by-step plan with tasks, timelines, and priorities.',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=700&q=80',
    imageAlt: 'AI processing visualization',
  },
  {
    number: '03',
    title: 'Execute and Track',
    desc: 'Follow your personalized plan, tick off tasks, and watch the AI adapt your schedule based on your progress.',
    image: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=700&q=80',
    imageAlt: 'Person tracking goals on phone',
  },
];

function HowItWorks() {
  return (
    <section id="how-it-works" className="py-28 bg-neutral-900/50 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-lavender-900/10 via-transparent to-lavender-800/5" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <p className="section-subtitle mb-3">Simple Process</p>
          <h2 className="section-title">
            From idea to plan<br />
            <span className="gradient-text">in three steps</span>
          </h2>
        </div>

        <div className="flex flex-col gap-20">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className={`grid lg:grid-cols-2 gap-12 items-center ${idx % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`}
              style={{ direction: idx % 2 !== 0 ? 'rtl' : 'ltr' }}
            >
              {/* Text */}
              <div style={{ direction: 'ltr' }}>
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-lavender-gradient font-display font-bold text-xl text-white shadow-lavender mb-6">
                  {step.number}
                </div>
                <h3 className="font-display text-3xl md:text-4xl font-bold mb-4">{step.title}</h3>
                <p className="text-white/55 text-lg leading-relaxed mb-6">{step.desc}</p>
                <ul className="flex flex-col gap-2">
                  {['Works offline too', 'Customizable output', 'Smart reminders'].map(feat => (
                    <li key={feat} className="flex items-center gap-2 text-white/70 text-sm">
                      <CheckIcon /> {feat}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Image */}
              <div style={{ direction: 'ltr' }} className="relative">
                <div className="absolute inset-0 bg-lavender-600/20 rounded-3xl blur-2xl scale-105" />
                <div className="relative rounded-3xl overflow-hidden border border-lavender-500/20 shadow-lavender">
                  <img
                    src={step.image}
                    alt={step.imageAlt}
                    className="w-full h-72 md:h-80 object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/60 to-transparent" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── Testimonials ─────────────────────────────────────────────────────────────
const testimonials = [
  {
    name: 'Sarah Chen',
    role: 'Product Manager, Google',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&q=80',
    stars: 5,
    text: 'MindPlan AI completely transformed how I approach complex projects. The AI-generated plans are surprisingly accurate and save me hours every week.',
  },
  {
    name: 'Marcus Williams',
    role: 'Entrepreneur & Startup Founder',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&q=80',
    stars: 5,
    text: 'I use MindPlan every single day for business strategy. The mind mapping feature alone is worth downloading the app. Absolutely brilliant product.',
  },
  {
    name: 'Priya Sharma',
    role: 'PhD Student, MIT',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&q=80',
    stars: 5,
    text: 'As a researcher juggling multiple deadlines, this app keeps me sane. The smart scheduling adapts to my workflow in ways I never expected.',
  },
  {
    name: 'David Okafor',
    role: 'Creative Director, Agency Owner',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&q=80',
    stars: 5,
    text: 'My team adopted MindPlan AI for collaborative planning and the results have been phenomenal. Client presentations are sharper, deadlines are hit.',
  },
];

function Testimonials() {
  return (
    <section id="testimonials" className="py-28 bg-neutral-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-lavender-600/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="section-subtitle mb-3">User Reviews</p>
          <h2 className="section-title">
            Loved by thousands of<br />
            <span className="gradient-text">smart planners</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, idx) => (
            <div key={idx} className="glass-card p-7 hover:border-lavender-500/30 transition-all duration-500 hover:-translate-y-1 hover:shadow-lavender group">
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, i) => <StarIcon key={i} filled={i < t.stars} />)}
              </div>
              {/* Quote */}
              <p className="text-white/70 leading-relaxed mb-6 text-[15px]">"{t.text}"</p>
              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-lavender-500/30 group-hover:border-lavender-400/60 transition-colors duration-300"
                  loading="lazy"
                />
                <div>
                  <p className="font-semibold text-white text-sm">{t.name}</p>
                  <p className="text-white/40 text-xs mt-0.5">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Play Store badge */}
        <div className="text-center mt-12 flex items-center justify-center gap-3">
          <div className="flex -space-x-2">
            {testimonials.slice(0,3).map((t,i) => (
              <img key={i} src={t.avatar} alt="" className="w-8 h-8 rounded-full border-2 border-lavender-600 object-cover" />
            ))}
          </div>
          <p className="text-white/50 text-sm">
            Rated <span className="text-lavender-300 font-semibold">4.8/5</span> on the Play Store by <span className="text-lavender-300 font-semibold">12,000+</span> users
          </p>
        </div>
      </div>
    </section>
  );
}

// ─── Download CTA ─────────────────────────────────────────────────────────────
function DownloadCTA() {
  return (
    <section id="download" className="py-28 relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-cta-gradient" />
      <div className="absolute inset-0 bg-noise opacity-40" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-lavender-400/10 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
          <span className="text-white/80 text-sm font-medium">Available Now on Android & iOS</span>
        </div>

        <h2 className="font-display text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
          Start planning smarter<br />today. It's free.
        </h2>

        <p className="text-white/70 text-xl mb-12 max-w-xl mx-auto leading-relaxed">
          Join over 50,000 users who have transformed their productivity with MindPlan AI. No credit card required.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://play.google.com/store"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-lavender-700 font-bold px-8 py-4 rounded-full hover:bg-lavender-50 transition-all duration-300 hover:scale-105 shadow-xl text-lg"
          >
            <PlayStoreIcon />
            Download on Play Store
          </a>
          <a
            href="https://apps.apple.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm text-white font-bold px-8 py-4 rounded-full border-2 border-white/30 hover:bg-white/20 transition-all duration-300 hover:scale-105 text-lg"
          >
            <AppStoreIcon />
            Download on App Store
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-12 text-white/50 text-sm">
          <div className="flex items-center gap-2">
            <ShieldIcon />
            <span>End-to-end Encrypted</span>
          </div>
          <span className="w-px h-4 bg-white/20" />
          <div className="flex items-center gap-2">
            <CheckIcon />
            <span>No Ads, No Spam</span>
          </div>
          <span className="w-px h-4 bg-white/20" />
          <div className="flex items-center gap-2">
            <CheckIcon />
            <span>Free Forever Plan</span>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── Footer ───────────────────────────────────────────────────────────────────
function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-950 border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-xl bg-lavender-gradient flex items-center justify-center shadow-lavender">
                <BrainIcon />
              </div>
              <span className="font-display font-bold text-lg">MindPlan AI</span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed">
              AI-powered planning for modern minds. Think smarter, achieve more.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4 tracking-wide">Product</h4>
            <ul className="flex flex-col gap-3">
              {['Features', 'How It Works', 'Download', 'Pricing'].map(item => (
                <li key={item}>
                  <a href="#" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4 tracking-wide">Legal</h4>
            <ul className="flex flex-col gap-3">
              <li><a href="/privacy-policy" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">Privacy Policy</a></li>
              <li><a href="/data-deletion" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">Data Deletion</a></li>
              <li><a href="#" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">Terms of Service</a></li>
              <li><a href="#" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">Cookie Policy</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4 tracking-wide">Contact</h4>
            <ul className="flex flex-col gap-3">
              <li><a href="mailto:support@mindplanai.com" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">support@mindplanai.com</a></li>
              <li><a href="#" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">Help Center</a></li>
              <li><a href="#" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">Twitter / X</a></li>
              <li><a href="#" className="text-white/40 text-sm hover:text-lavender-300 transition-colors duration-200">LinkedIn</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-sm">&copy; {currentYear} MindPlan AI. All rights reserved.</p>
          <div className="flex items-center gap-2 text-white/30 text-sm">
            <PlayStoreIcon />
            <span>Available on Play Store</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

// ─── Main Page ────────────────────────────────────────────────────────────────
export default function LandingPage() {
  return (
    <div className="bg-neutral-950 text-white min-h-screen">
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <Testimonials />
      <DownloadCTA />
      <Footer />
    </div>
  );
}
